module.exports = __webpack_public_path__ + "static/media/image-plus.f97023fc.svg";